import { render } from "./UserConfigMenu.vue?vue&type=template&id=2e1b6dd7&scoped=true"
import script from "./UserConfigMenu.vue?vue&type=script&lang=js"
export * from "./UserConfigMenu.vue?vue&type=script&lang=js"

import "./UserConfigMenu.vue?vue&type=style&index=0&id=2e1b6dd7&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1b6dd7"]])

export default __exports__